// Default fallback image for citation.image_url if image isn't provided or it 404s
export const CITATION_FALLBACK_IMAGE_URL =
    "https://rwa-partners-infra-prod-rwapartnersuploads740d2985-1c2klgo7i3ef.s3.us-east-1.amazonaws.com/uploads/media-admin/images/rwa_circular.png";
